/* -----------------Child components--------------- */
import DocumentTitle from "components/DocumentTitle";

import { pageViewTypes } from "@constants/tracking";
/* -----------------Types--------------- */
import ReportContainer from "@features/report/screens/ReportContainer";
import useAnalytics from "@hooks/useAnalytics";
import { useMemo } from "react";

const ReportRoute = () => {
	const memoizedAnalyticsParams = useMemo(() => {
		return {
			type: pageViewTypes.report,
		};
	}, []);
	useAnalytics(memoizedAnalyticsParams);
	return (
		<>
			<DocumentTitle title={"Report"} />
			<ReportContainer />
		</>
	);
};

export default ReportRoute;
